import { render, staticRenderFns } from "./Accessories.vue?vue&type=template&id=31c758ff&scoped=true&"
import script from "./Accessories.vue?vue&type=script&lang=js&"
export * from "./Accessories.vue?vue&type=script&lang=js&"
import style0 from "./Accessories.vue?vue&type=style&index=0&id=31c758ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c758ff",
  null
  
)

export default component.exports